// extracted by mini-css-extract-plugin
export var layout = "SearchMenu-module--layout--32ff7";
export var searchInput = "SearchMenu-module--searchInput--1e355";
export var searchMenu = "SearchMenu-module--searchMenu--32905";
export var visible = "SearchMenu-module--visible--177cd";